import { DatePicker } from '@mui/x-date-pickers';
import { useId } from 'react';
import { FilterField } from './FilterField';

export interface DateFilterProps {
  label: string;
  value: Date | null;
  onChange: (date: Date | null) => void;
  format?: string;
  disabled?: boolean;
  minDate?: Date;
  maxDate?: Date;
}

export function DateFilter({
  label,
  value,
  onChange,
  format,
  disabled,
  minDate,
  maxDate,
}: DateFilterProps) {
  const inputId = useId();

  return (
    <FilterField label={label} htmlFor={inputId}>
      <DatePicker
        value={value}
        onChange={onChange}
        format={format}
        disabled={disabled}
        minDate={minDate}
        maxDate={maxDate}
        slotProps={{
          field: { clearable: true },
          // Small and full width, like the other filter inputs. The height and
          // radius come from the theme's outlined input, so overriding them here
          // would be what makes the date field look different.
          textField: { id: inputId, size: 'small', fullWidth: true },
          openPickerButton: { size: 'small' },
          clearButton: { size: 'small' },
        }}
      />
    </FilterField>
  );
}
